import { useCallback, useRef } from 'react';

const SOUNDS = {
  startup: 'https://www.myinstants.com/media/sounds/windows-xp-startup.mp3',
  click: 'https://www.myinstants.com/media/sounds/windows-navigation-start.mp3',
  error: 'https://www.myinstants.com/media/sounds/windows-xp-error.mp3',
  msn: 'https://www.soundjay.com/communication/sounds/computer-beep-1.mp3',
};

export const useSound = () => {
  const audioRef = useRef(null);

  const playSound = useCallback((soundName, volume = 0.5) => {
    try {
      const soundUrl = SOUNDS[soundName];
      if (!soundUrl) return;

      if (audioRef.current) {
        audioRef.current.pause();
      }

      const audio = new Audio(soundUrl);
      audio.volume = volume;
      audioRef.current = audio;
      audio.play().catch(() => {
        // Silently fail if autoplay is blocked
      });
    } catch (e) {
      // Silently fail
    }
  }, []);

  return { playSound };
};

export default useSound;
